
const ControlCategories = {
  'general': 'Basic fields',
  'layout': 'Layout fields',
  'advanced': 'Advanced'
};

export { ControlCategories };
